import { validateEnumTranslations } from '../../safety_checks';

/**
 * Suivi de l'enrôlement d'un hôte servi (domaine custom, sous-domaine par défaut, hôte Propelsia)
 * chez chaque moteur de recherche (plan `docs/to_implement/seo/bing-webmaster-backlinks-plan.md`, D8).
 *
 * ⚠️IMPACT — miroir des enums Prisma `SearchEngine` et `SearchEnginePropertyStatus`
 * (packages/backend/prisma-pg/schema.prisma). Toute valeur ajoutée ici doit l'être aussi côté
 * Prisma (migration additive), et inversement. Jamais montré au pro : admin uniquement.
 */
export enum SearchEngine {
  GSC = 'GSC',
  BING = 'BING',
}

export enum SearchEnginePropertyStatus {
  /** Jamais tenté (hôte servi mais inconnu du moteur). */
  NONE = 'NONE',
  /** En cours : token / balise posés, vérification en attente du crawl. */
  PENDING = 'PENDING',
  /** Propriété créée chez le moteur mais pas (encore) vérifiée. */
  ADDED = 'ADDED',
  VERIFIED = 'VERIFIED',
  /** Abandon après les tentatives prévues : voir `last_error`. */
  FAILED = 'FAILED',
  /** Hôte non concerné : domaine secondaire qui redirige, site dépublié ou supprimé. */
  SKIPPED = 'SKIPPED',
}

export const TRANSLATE_KEY_SEARCH_ENGINE = 'SEARCH_ENGINE_';
export const TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS = 'SEARCH_ENGINE_PROPERTY_STATUS_';

export const SearchEngineTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SEARCH_ENGINE}${SearchEngine.GSC}`]: 'Google Search Console',
    [`${TRANSLATE_KEY_SEARCH_ENGINE}${SearchEngine.BING}`]: 'Bing Webmaster',
  },
};

export const SearchEnginePropertyStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.NONE}`]: 'Non déclaré',
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.PENDING}`]: 'Vérification en cours',
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.ADDED}`]: 'Déclaré, non vérifié',
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.VERIFIED}`]: 'Vérifié',
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.FAILED}`]: 'Échec',
    [`${TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS}${SearchEnginePropertyStatus.SKIPPED}`]: 'Sans objet',
  },
};

/** Statuts qui n'appellent aucune action : vérifié, ou hôte hors périmètre. */
export const SEARCH_ENGINE_PROPERTY_SETTLED_STATUSES: readonly SearchEnginePropertyStatus[] = [
  SearchEnginePropertyStatus.VERIFIED,
  SearchEnginePropertyStatus.SKIPPED,
];

//DONT TOUCH below this line
validateEnumTranslations(SearchEngine, SearchEngineTranslation, TRANSLATE_KEY_SEARCH_ENGINE, true);
validateEnumTranslations(
  SearchEnginePropertyStatus,
  SearchEnginePropertyStatusTranslation,
  TRANSLATE_KEY_SEARCH_ENGINE_PROPERTY_STATUS,
  true,
);
